import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Spin, message} from 'antd';
import {projectsApi} from '@/api/projects';
import type {AccessGrantedState} from '@/types/api';

const SharePage: React.FC = () => {
	const {token} = useParams<{token: string}>();
	const navigate = useNavigate();
	const [status, setStatus] = useState<'loading' | 'done'>('loading');

	useEffect(() => {
		if (!token) {
			navigate('/', {replace: true});
			return;
		}

		projectsApi.getShareInfo(token).then(({data, error, status: responseStatus}) => {
			if (error || !data) {
				setStatus('done');
				if (responseStatus === 401) {
					navigate('/login', {
						state: {from: {pathname: `/share/${token}`}},
						replace: true,
					});
					return;
				}
				message.error(error?.message || 'Ссылка недействительна или истекла');
				navigate('/', {replace: true});
				return;
			}

			void projectsApi.acceptShare(token).then(res => {
				setStatus('done');
				if (res.status === 401) {
					navigate('/login', {
						state: {from: {pathname: `/share/${token}`}},
						replace: true,
					});
					return;
				}
				if (res.error || !res.data) {
					message.error(res.error?.message || 'Не удалось получить доступ к проекту');
					navigate('/', {replace: true});
					return;
				}
				const accessGranted: AccessGrantedState = {
					projectName: res.data.projectName,
					role: res.data.role,
					alreadyMember: Boolean(res.data.alreadyMember),
				};
				navigate('/', {replace: true, state: {accessGranted}});
			});
		});
	}, [token, navigate]);

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}
		>
			{status === 'loading' && <Spin size="large" />}
		</div>
	);
};

export default SharePage;
